import { render, staticRenderFns } from "./EditItemSummary.vue?vue&type=template&id=786bbbbd&scoped=true&"
import script from "./EditItemSummary.vue?vue&type=script&lang=js&"
export * from "./EditItemSummary.vue?vue&type=script&lang=js&"
import style0 from "./EditItemSummary.vue?vue&type=style&index=0&id=786bbbbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786bbbbd",
  null
  
)

export default component.exports